module.exports = {
    Languages : [
        'C#',
        'Python',
        'HTML',
    ],
    // These need to be the Font Awesome code https://fontawesome.com/
    Tools : [
        'fab fa-unity',
        'fab fa-github',
        'fab fa-linux',
        'fab fa-ubuntu',
        'fab fa-aws',
    ]
}